<template>
	<div class="site">
		<Nav/>
		<div id="content" class="site-content">
			<div style="min-height: 380px;">
				<img src="../../assets/images/CRM-banner-new.jpg" style="object-fit: cover;width: 100%;height:380px;">
			</div>
			<div id="primary" class="content-area normal">
				<div id="contentHolder" style="transform: none;">
					<div class="rowContainer container-custom">
						<div class="row wrapper">
							<div class="col-xl-8 content">
								<div class="blog-box show-image no-preview" v-for="item in blogList">
									<router-link :to="`/${item.title}`">
										<div class="blog-img-holder">
											<div class="blog-img normal">
												<a class="img-opacity-hover">
													<img style="max-width: 100%;height: auto;cursor:pointer;" :src="item.firstPicture" class="img-responsive wp-post-image" alt="" decoding="async"  title="">									
												</a>
												</div>				
											</div>
											<div class="entry-content">
												<div class="cat-ratint-wrap">
													<div class="entry-categories">				
													<!-- <a href="https://netsparks.online/category/crm/"> -->
														<span class="category-style" style="background:rgba(17, 17, 17,0.1)">
															<span class="category-color" style="color:#111111">{{ item.category.name }}</span>
														</span>
													<!-- </a> -->
												</div>
												<div class="rtrs-rating-item">
													<div class="rating-icon">
														<div class="rating-list">
															<el-rate
																v-model="item.rate"
																disabled
																show-score
																text-color="#000"
																score-template="">
															</el-rate>
														</div>
														<span>({{ item.views }})</span>
													</div>			        
												</div>
											</div>
											<h2 class="entry-title title-animation-black-normal">
												{{ item.title }}
											</h2>
											<ul class="entry-meta">
												<li class="post-author">by <a title="Posts by admin" rel="author">admin</a>
												</li>
												<li class="post-date">{{ formatDate(item.createTime) }}</li>				
											</ul>
											<div class="entry-text">
												<p v-html="item.content" style="max-height: 60px;display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;"></p>
											</div>
										</div>
									</router-link>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;">
									<el-pagination :page-size="5" @current-change="handleCurrentChange" :current-page="pageNum" :page-count="totalPage"
										layout="prev, pager, next" background >
									</el-pagination>
								</div>
							</div>
							<div class="col-xl-4 mx-auto fixed-bar-coloum sidebar" style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
								<MainSidebar></MainSidebar>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<!-- <div class="ui top segment" style="text-align: center">
			<h2 class="m-text-500">分类 {{ categoryName }} 下的文章</h2>
		</div> -->
		<!-- <BlogList :getBlogList="getBlogList" :blogList="blogList" :totalPage="totalPage"/> -->
		<Foot></Foot>
	</div>
</template>

<script>
	import BlogList from "@/components/blog/BlogList";
	import {getBlogListByCategoryName} from "@/api/category";
	import Nav from "@/components/index/Nav";
	import Foot from "@/components/index/Foot";
	import {mapState} from "vuex";
	import MainSidebar from "@/components/sidebar/MainSidebar.vue";


	export default {
		name: "Category",
		components: {BlogList,Nav,Foot,MainSidebar},
		data() {
			return {
				blogList: [],
				totalPage: 0,
				categoryList:[],
				pageNum: 1,
				quality: 5
			}
		},
		watch: {
			//在当前组件被重用时，要重新获取博客列表
			'$route.fullPath'() {
				if (this.$route.name === 'category') {
					this.getBlogList()
				}
			}
		},
		created() {
			this.pageNum = 1
			this.getBlogList()
		},
		computed: {
			...mapState([ 'clientSize','siteInfo', 'focusMode','parentCommentId', 'commentForm', 'commentQuery','comments','commentCount','commentTotalPage']),
			categoryName() {
				return this.$route.params.name
			}
		},
		methods: {
			formatDate(isoString) {
				const date = new Date(isoString);
				const options = { year: 'numeric', month: 'long', day: 'numeric' };
				return date.toLocaleDateString('en-US', options);
			},
			handleCurrentChange(newPage) {
				//如果是首页，则滚动至Header下方
				if (this.$route.name === 'home') {
					window.scrollTo({top: this.clientSize.clientHeight, behavior: 'smooth'})
				} else {
					//其它页面（分类和标签页）滚动至顶部
					this.scrollToTop()
				}
				this.pageNum = newPage
				this.getBlogList(newPage)
			},
			getBlogList(pageNum) {
				getBlogListByCategoryName(this.categoryName, pageNum).then(res => {
					if (res.code === 200) {
						this.blogList = res.data.list
						this.totalPage = res.data.totalPage
						this.$nextTick(() => {
							Prism.highlightAll()
						})
					} else {
						this.msgError(res.msg)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			}
		}
	}
</script>

<style scoped>
	.site {
		display: flex;
		min-height: 100vh; /* 没有元素时，也把页面撑开至100% */
		flex-direction: column;
	}
	.site-content {
		position: relative;
		background-color: #fff;
		z-index: 1;
		transition: allease 0.31s;
	}
	.content-area {
		padding-top: 100px;
		padding-bottom: 100px;
	}
	.container-custom {
		max-width: 1548px;
		margin: 0 auto;
		padding-left: 12px;
		padding-right: 12px;
	}
	.row {
		--bs-gutter-x: 1.5rem;
		--bs-gutter-y: 0;
		display: flex;
		flex-wrap: wrap;
		margin-top: calc(-1* var(--bs-gutter-y));
		margin-right: calc(-.5* var(--bs-gutter-x));
		margin-left: calc(-.5* var(--bs-gutter-x));
	}
	@media (min-width: 1200px) {
		.col-xl-8 {
			flex: 0 0 auto;
			width: 66.66666667%;
			padding-right: 10px;
		}
		.col-xl-4 {
			flex: 0 0 auto;
			width: 33.33333333%;
			padding-left: 10px;
		}
	}
	@media (max-width: 1200px) {
		.col-xl-8 {
			flex: 0 0 auto;
			width: 100%;
		}
		.col-xl-4 {
			flex: 0 0 auto;
			width: 100%;
		}
		.m-search{
			width: 100% !important;
		}
	}
	.row > * {
		--bs-gutter-x: 1.5rem;
    	--bs-gutter-y: 0;
		/* flex-shrink: 0; */
		/* width: 100%; */
		max-width: 100%;
		padding-right: calc(var(--bs-gutter-x)* .5);
		padding-left: calc(var(--bs-gutter-x)* .5);
		margin-top: var(--bs-gutter-y);
	}
	.blog-box {
		border-radius: 15px;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		background-color: #fff;
		overflow: hidden;
		margin-bottom: 30px;
		transition: all ease 0.31s;
		position: relative;
	}
	.blog-box .blog-img-holder {
		position: relative;
		overflow: hidden;
		
	} 
	.blog-box .blog-img-holder:hover .img-opacity-hover img{
		transform: scale(1.1);
	}
	img {
		max-width: 100%;
		height: auto;
	}
	
	.blog-box * {
		box-sizing: border-box;
	}
	.blog-box .blog-img-holder .blog-img img {
		transform: scale(1.01);
		transition: all 1s cubic-bezier(0.25, 0.8, 0.25, 1);
	}
	.blog-box.show-image .entry-content {
		position: relative;
		padding: 30px;

	}
	.entry-content:before{
		content: "";
		display: table;
		table-layout: fixed;
	}
	.cat-ratint-wrap {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 13px;
	}
	.entry-categories {
		display: inline-flex;
		flex-wrap: wrap;
		gap: 5px;
	}
	.entry-categories .category-style {
		display: inline-flex;
		font-size: 14px;
		color: #fff;
		border-radius: 4px;
		padding: 8px 15px 8px;
		font-weight: 500;
		letter-spacing: 0.7px;
		line-height: 1;
		transition: allease 0.31s;
	}
	.category-style span {
		font-size: 9px;
	}
	.rtrs-rating-item .rating-icon {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
		line-height: 1;
	}
	.rtrs-rating-item .rating-icon span {
		color: #777777;
		font-size: 14px;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: all ease 0.31s;
	}
	.blog-box .entry-content .entry-title {
		font-size: 26px;
		line-height: 1.4;
    	margin-bottom: 5px;
	}
	.blog-box .entry-content .entry-title a {
		color: #161f38;
	}
	.title-animation-black-normal a {
		background-image: linear-gradient(to right, #161f38 0%, #161f38 98%);
		background-repeat: no-repeat;
		background-position: left 90%;
		background-size: 0 2px;
		transition: all 0.7s;
	}
	.blog-box ul.entry-meta {
		list-style: none;
		margin: 0 0 12px;
		padding: 0;
	}
	.blog-box ul.entry-meta li {
		display: inline-block;
		color: #777777;
		font-size: 14px;
		font-weight: 500;
		margin-right: 7px;
		position: relative;
		letter-spacing: 0.2px;
		text-transform: capitalize;
		transition: allease 0.31s;
	}

	.post-author {
		display: none !important;
	}
	.blog-box ul.entry-meta li.post-author a {
		color: #161f38;
		font-weight: 600;
	}
	.blog-box ul.entry-meta li:last-child {
		margin-right: 0;
	}

	.blog-box ul.entry-meta li {
		display: inline-block;
		color: #777777;
		font-size: 14px;
		font-weight: 500;
		margin-right: 7px;
		position: relative;
		letter-spacing: 0.2px;
		text-transform: capitalize;
		transition: allease 0.31s;
	}
	.entry-content .entry-text {
		color: #6c6f72;
		transition: allease 0.31s;
	}
	.entry-text {
		counter-reset: footnotes;
		font-family: 'Inter', sans-serif !important;
		font-size: 16px;
		font-weight: normal;
		font-style: normal;
		color: #6c6f72;
	}
	.entry-text ::v-deep {
		p {
			margin: 0 0 20px 0;
			line-height: 28px;
			
			img {
				width: 100%;
				height: auto;
			}
		}
	}
	.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
		background-color: #ffffff !important;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #409EFF !important;
	}
</style>